import { render, staticRenderFns } from "./ShiftVDPLaboratory.vue?vue&type=template&id=c8ec25ae&"
import script from "./ShiftVDPLaboratory.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPLaboratory.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftVDPLaboratory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports